/**
 * Is a chart attachment an HTML document rather than an image?
 *
 * It matters because the two mount differently and only one of them fails visibly. The backend's
 * charts are standalone Plotly documents — the historian stamps them `base64_html` and packs them
 * as a `data:text/html;base64,…` URI — and an `<img>` cannot decode one, so it fires `onError` and
 * the user gets "Chart not available" where a chart should be. A document mounts in a sandboxed
 * iframe, which is how the legacy chat has always rendered them.
 *
 * Read from the ATTACHMENT (its declared media type, or the MIME inside its own data URI) rather
 * than from which backend produced it, so an image attachment keeps the image path untouched.
 */

/** What the historian stamps on a chart it packaged as a standalone document. */
const HTML_MEDIA_TYPES = new Set(['base64_html', 'text/html']);

export function isHtmlChart(src: string, mediaType?: string): boolean {
  if (mediaType && HTML_MEDIA_TYPES.has(mediaType.toLowerCase())) return true;
  return /^data:text\/html[;,]/i.test(src);
}
